import attachment from "@/interfaces/attachment";
import store from '@/store';
import axios from "axios";

export default {
	makeAttachmentDownloadLink(attachment: attachment): string {
		let baseUrl = axios.defaults.baseURL;
		const org = store.state.org;

		if (org == null) {
			console.warn("Organization can't be detected");
			return "#";
		}

		if (baseUrl == null) {
			console.warn("Axios baseurl null");
			return "#";
		}

		if (baseUrl[baseUrl.length - 1] == "/") {
			baseUrl = baseUrl.substr(0, baseUrl.length - 1);
		}
		return `${baseUrl}/Attachments/Download/${org}/${attachment.fileHash}/${attachment.uniqueIdentifier}`;
	}
}